import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LinkList from '../../../misc/link-list.js';
import useTranslations from '../../../translation/use-translations';
import { fetchAdNotificationsEnabled } from '../ducks/we-spin-duck.js';
import { selectIsAdNotificationsEnabled } from '../ducks/we-spin-selectors.js';
import { WE_SPIN_ACCOUNT_TEXT_KEYS } from '../constants/we-spin-text-keys.js';

const WeSpinNotificationOptOutLinkList = ({ className, to }) => {
	const dispatch = useDispatch();
	const isAdNotificationsEnabled = useSelector(selectIsAdNotificationsEnabled);
	const { translations: tr, isLoadingTranslations } = useTranslations(WE_SPIN_ACCOUNT_TEXT_KEYS);
	useEffect(() => {
		dispatch(fetchAdNotificationsEnabled());
	}, [dispatch]);

	return (
		!isLoadingTranslations && (
			<LinkList
				className={className}
				to={to}
				title={tr.WE_SPIN_ACCOUNT_NOTIFICATION_OPT_OUT_TITLE}
				value={
					isAdNotificationsEnabled
						? tr.WE_SPIN_ACCOUNT_NOTIFICATIONS_ON
						: tr.WE_SPIN_ACCOUNT_NOTIFICATIONS_OFF
				}
			/>
		)
	);
};

export default WeSpinNotificationOptOutLinkList;
